export interface ChatCommand {
    command: string;
    description: string;
}

/** Commands implemented by AIChatbot; shared by help and input discovery. */
export const CHAT_COMMANDS: ChatCommand[] = [
    { command: '/help', description: 'Show available commands' },
    { command: '/about', description: 'Explore Abhijith’s background and experience' },
    { command: '/skills', description: 'Find his technical skills and expertise' },
    { command: '/projects', description: 'Discover his projects' },
    { command: '/contact', description: 'Find ways to get in touch' },
    { command: '/persona', description: 'Describe yourself to create a custom site theme' },
    { command: '/tools', description: 'See what Eos can do' },
    { command: '/states', description: 'Preview Eos’s seven motion states' },
    { command: '/genui', description: 'Render a live OpenUI Lang generative UI card' },
    { command: '/experiments', description: 'Browse interactive experiments' },
    { command: '/theme', description: 'Switch between light, dark, and system themes' },
    { command: '/reset-theme', description: 'Reset your custom theme' },
    { command: '/clear', description: 'Clear this conversation' },
];

export const SLASH_COMMANDS: Record<string, string> = Object.fromEntries(
    CHAT_COMMANDS.map(({ command, description }) => [command, description]),
);

SLASH_COMMANDS['/help'] = `Available: ${CHAT_COMMANDS.filter(item => item.command !== '/help').map(item => item.command).join(' ')}`;
